import { render, staticRenderFns } from "./AddEditUser.vue?vue&type=template&id=36b75bf3&"
import script from "./AddEditUser.vue?vue&type=script&lang=js&"
export * from "./AddEditUser.vue?vue&type=script&lang=js&"
import style0 from "./AddEditUser.vue?vue&type=style&index=0&id=36b75bf3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports